import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarCollapsed } from "../ui.slice";
import { RootState } from "../../store";

export function useSidebarCollapsed() {
  const dispatch = useDispatch();
  const isSidebarCollapsed = useSelector((s: RootState) => s.ui.isSidebarCollapsed);

  const setCollapsed = useCallback(
    (collapsed: boolean) => dispatch(setSidebarCollapsed(collapsed)),
    [dispatch],
  );

  return useMemo(() => ({ isSidebarCollapsed, setCollapsed }), [isSidebarCollapsed, setCollapsed]);
}
